module.exports = __webpack_public_path__ + "img/booking_thanks.770acb9b.png";